import { divide } from 'number-precision'
import { isNumber } from '@utopia-utils/core'

/**
 * 金额 分转元
 * @param fen 分
 * @returns 元, 如果输入不是数字，则返回 ''
 * */

export function fenToYuan(fen?: number): number | null {
  try {
    if (!isNumber(fen) || Number.isNaN(fen))
      return null

    return divide(fen, 100)
  }
  catch (err) {
    console.error(err)
    return null
  }
}
